import { datadogRum } from '@datadog/browser-rum';

export const configureRUM = () => {
  try {
    return datadogRum.init({
      applicationId: '60f4ac95-c679-4419-b822-aac021990010',
      clientToken: 'puba16e1c1ac477f11417eae1573bcea2bb',
      // `site` refers to the Datadog site parameter of your organization
      // see https://docs.datadoghq.com/getting_started/site/
      site: 'datadoghq.com',
      service: 'portal-rum',
      // eslint-disable-next-line no-nested-ternary
      env: window.location.hostname.split('.')[0],
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask-user-input',
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      version: VERSION, // VERSION is injected at build time
      startSessionReplayRecordingManually: true,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      // This allows correlation of RUM and APM traces on matching urls
      // see https://docs.datadoghq.com/tracing/other_telemetry/rum?tab=browserrum
      allowedTracingUrls: [
        /^https:\/\/[^/]+\.console\.hayden\.ai/,
      ]
    });
  } catch (error) {
    // Ignore errors thrown during CloudWatch RUM web client initialization
    console.error(error);
  }
};
